import $ from "jquery";
import {active} from "./const.js";
import mapster from "imagemapster";

$('.c-map2__bg').mapster({
  clickNavigate: true,
  mapKey:        'href',
  fillColor:     'CDAB7A',
  fillOpacity:    1
});
